/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryGa4ReportRowData
 */
export interface GoogleBigQueryGa4ReportRowData {
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    key?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    events?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    sessions?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    purchases?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    revenue?: string;
}

/**
 * Check if a given object implements the GoogleBigQueryGa4ReportRowData interface.
 */
export function instanceOfGoogleBigQueryGa4ReportRowData(value: object): value is GoogleBigQueryGa4ReportRowData {
    return true;
}

export function GoogleBigQueryGa4ReportRowDataFromJSON(json: any): GoogleBigQueryGa4ReportRowData {
    return GoogleBigQueryGa4ReportRowDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4ReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4ReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'events': json['events'] == null ? undefined : json['events'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'purchases': json['purchases'] == null ? undefined : json['purchases'],
        'revenue': json['revenue'] == null ? undefined : json['revenue'],
    };
}

export function GoogleBigQueryGa4ReportRowDataToJSON(json: any): GoogleBigQueryGa4ReportRowData {
    return GoogleBigQueryGa4ReportRowDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4ReportRowDataToJSONTyped(value?: GoogleBigQueryGa4ReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'events': value['events'],
        'sessions': value['sessions'],
        'purchases': value['purchases'],
        'revenue': value['revenue'],
    };
}

